import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperAbout = () => {
  new Swiper('.swiper-about', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    speed: 600,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true, // Це приховає попередній слайд під час анімації
    },
    breakpoints: {
      320: {
        slidesPerView: 1.05,
        direction: 'vertical',
      },
      1440: {
        slidesPerView: 1,
        direction: 'horizontal',
      },
    },
  });
};

export default swiperAbout;
